"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z"
}), 'CalendarViewDay');